<template>
    <div>
        <Alert type="info" v-if="statusStock != 1 && statusStock != 2 && !isKit">
            Produto com estoque em movimentação, não é permitido alterar alguns campos!
        </Alert>
        <b-row>
            <b-col v-if="!operational || showListKitOrAccessory" sm="12">
                <Select title="Período de Locação" field="type" :required="true" :markFormDirty="false"
                    :disabled="statusStock != 1 && statusStock != 2" :formName="formName"
                    :propsParams="{ any: itemsRent.rentId }" :showNewRegister="false"
                    url="/api/v1/rental/period-rent/select-all" v-model="itemsRent.periodRent" />
            </b-col>
        </b-row>

        <b-row>
            <b-col v-show="!isKit" xs="12" sm="12" md="12" lg="5" xl="5">
                <Select title="Tipo" field="type" :formName="formName" :required="true"
                    :disabled="statusStock != 1 && statusStock != 2" :markFormDirty="false"
                    url="/api/v1/stock/type-product/select-all" :showNewRegister="false" v-model="itemsRent.typeProduct"
                    :changed="onCleanProduct" />
            </b-col>

            <b-col v-show="!isKit" xs="12" sm="12" md="12" lg="7" xl="7">
                <Select title="Produto" field="product" :formName="formName" :required="true" :markFormDirty="false"
                    url="/api/v1/stock/product/select-all" :propsParams="{ any: itemsRent.typeProduct.id }"
                    :disabled="isDisabledProduct" :showNewRegister="false" v-model="itemsRent.product" />
            </b-col>
        </b-row>

        <b-row>
            <b-col sm="12">
                <EditorHtml title="Descrição" field="description" :required="false" :markFormDirty="false"
                    :maxLength="20000" v-model="itemsRent.description" />
            </b-col>
        </b-row>

        <Alert type="info" v-if="statusInvoice == 2 && !operational">
            O produto já foi <b>Faturado</b>. As condições comerciais não podem mais ser alteradas.
        </Alert>


        <div v-if="isKit && !showListKitOrAccessory">
            <b-row>
                <b-col sm="2">
                    <InputNumber title="Quantidade" field="quantity" :formName="formName" :required="false"
                        :disabled="false" :markFormDirty="false" :maxLength="5" type="float"
                        v-model="itemsRent.quantity" />
                </b-col>
            </b-row>
        </div>

        <b-row v-show="!isKit || showListKitOrAccessory">
            <b-col v-if="operational && !itemsRent.onlyStock" sm="2">
                <InputNumber title="Quantidade" field="quantity" :formName="formName" :required="false" :disabled="true"
                    :markFormDirty="false" :maxLength="5" type="float" v-model="itemsRent.quantity" />
            </b-col>
            <b-col v-else sm="2">
                <InputNumber title="Quantidade" field="quantity" :formName="formName" :required="false"
                    :disabled="statusStock == 5 || statusStock == 6 || statusInvoice == 2" :markFormDirty="false"
                    :maxLength="5" type="float" v-model="itemsRent.quantity" />
            </b-col>

            <b-col v-if="!operational" sm="3">
                <InputDecimal title="Valor Unitário" field="unitValue" :formName="formName" :required="false"
                    :markFormDirty="false" :disabled="statusInvoice == 2" :maxLength="10" :precision="8" type="float"
                    v-model="itemsRent.unitValue" />
            </b-col>

            <b-col v-if="!operational" sm="3">
                <InputDecimalDiscount title="Desconto Unitário" field="unitDiscount" :formName="formName"
                    :required="false" _style="color:red;" :disabled="statusInvoice == 2" :maxLength="8" :precision="8"
                    type="float" v-model="itemsRent.discount" />
            </b-col>

            <b-col v-if="!operational" sm="2">
                <InputDecimal title="Custo Unitário" field="unitCost" :formName="formName" :required="false"
                    :markFormDirty="false" :disabled="statusInvoice == 2" _style="color:red;" :maxLength="10"
                    :precision="2" type="float" v-model="itemsRent.unitCost" />
            </b-col>

            <b-col v-if="!operational" sm="2">
                <InputDecimal title="Seguro Unitário" field="unitInsurance" :formName="formName" :required="false"
                    :markFormDirty="false" :disabled="statusInvoice == 2" :maxLength="10" :precision="2" type="float"
                    v-model="itemsRent.unitInsurance" />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import InputDecimalDiscount from "@nixweb/nixloc-ui/src/component/forms/InputDecimalDiscount";
import InputNumber from "@nixweb/nixloc-ui/src/component/forms/InputNumber";
import InputDecimal from "@nixweb/nixloc-ui/src/component/forms/InputDecimal";
import Select from "@nixweb/nixloc-ui/src/component/forms/Select";
import EditorHtml from "@nixweb/nixloc-ui/src/component/forms/EditorHtml";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import GroupRentCreateUpdate from "../group-rent/GroupRentCreateUpdate.vue";

export default {
    name: "ItemRentSection",
    components: {
        InputDecimalDiscount,
        InputNumber,
        InputDecimal,
        Select,
        EditorHtml,
        Alert,
        GroupRentCreateUpdate,
    },
    props: {
        itemsRent: { type: Object, required: true },
        formName: { type: String, required: true },
        statusStock: { type: Number, required: true },
        statusInvoice: { type: Number, required: true },
        isDisabledProduct: { type: Boolean, required: true },
        operational: { type: Boolean, default: false },
        showListKitOrAccessory: { type: Boolean, default: false }

    },
    computed: {
        isKit() {
            return this.itemsRent.kitId ? true : false;
        },
        isMainKit() {
            return this.itemsRent.mainKit;
        }
    },
    methods: {
        onCleanProduct() {
            this.$emit("clean-product");
        },
    },
};
</script>
